import {Component, Injector, NgZone, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {PlayerBaseService} from '../../services/PlayerService/player.base.service';
import {Log, LogTag} from '../../services/Log';
import {concatMap, filter, Observable, of, startWith, switchMap} from 'rxjs';
import {delay, map, take} from "rxjs/operators";
import {RegDialogComponent} from "../reg-dialog/reg.dialog.component";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {PlayerPwaService} from "../../services/PlayerService/player.pwa.service";
import {DialogPopComponent} from "../../dialog-pop/dialog-pop.component";

interface IScene {
    id: number;
    label: string;
    mimeType: string;
}

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['../reg-dialog/reg.dialog.component.css', './registration.component.css']
})
export class RegistrationComponent extends RegDialogComponent implements OnInit {
  @ViewChild('stationName', {static: false}) stationName;
  @ViewChild('btnRegister', {static: false}) btnRegister;
  @ViewChild("popup", {read: TemplateRef}) popup: TemplateRef<any>;

  selected: IScene;
  popDialog;
  popupMessage;

  //m_scenes = [];
  m_scenes$: Observable<IScene[]>;
  m_answers: Array<IScene> = [];
  m_contGroup: FormGroup;
  m_stationName = 'My Player...'

  constructor(protected injector: Injector, public fb: FormBuilder, public dialog: MatDialog, private ngZone: NgZone) {
    super(injector);
    this.initForm();
  }

  ngOnInit() {
    this.disableUI(true);
    this.m_scenes$ = this.m_contGroup.controls['answerField'].valueChanges
      .pipe(
        startWith(''),
        map(value => {
          if (value.id) {
            this.onSelected(value);
            return this._filter(value.label);
          }
          return this._filter(value);
        })
      );
  }

  initForm() {
    this.m_contGroup = this.fb.group({
      answerField: ['', [Validators.required]]
    });
  }

  onSelected(value) {
    this.selected = value;
    this.m_contGroup.controls['answerField'].patchValue(value.label);
  }

  private _filter(value: string): any {
    return this.m_answers.filter(option => (option.label.toLowerCase().includes(value.toLowerCase()) && option.mimeType == "mainPlayer"));
  }

  cannotRegister() {
    this.popDialog = this.dialog.open(this.popup);
  }

  onClose() {
    this.popDialog.close();
  }

  clear() {
    this.selected = null;
    this.m_contGroup.controls['answerField'].setValue('');
  }

  register(): Observable<any> {
    const logInfo = Log.getLogInfo("RegistrationComponent", "register", []);
    return of('register').pipe(
      delay(20),
      concatMap(r => this.playerService.getSceneList()),
      concatMap(sceneList => {
        Log.d(logInfo, LogTag.REGISTRATION, sceneList);

        //this.m_scenes = sceneList; //Array(sceneList).filter(item => item.mimeType != "mainPlayer");
        this.m_answers = sceneList;

        this.disableUI(false);
        return this.click$;
      }),
      concatMap(r => {
        this.disableUI(true);
        this.playerService.sceneId = this.selected.id;
        const name = this.stationName.nativeElement.value;
        (this.playerService as PlayerPwaService).generateToken();
        const url = 'https://' + (this.playerService as PlayerBaseService).businessDomain + '/Web' +
          '/registerStation.ashx?user=' + (this.playerService as PlayerBaseService).data['user'] +
          '&pass=' + (this.playerService as PlayerBaseService).data['pass'] +
          '&stationToken=' + (this.playerService as PlayerBaseService).stationToken +
          '&stationName=' + name +
          '&sceneId=' + this.playerService.sceneId;
        Log.d(logInfo, LogTag.REGISTRATION, url);
        return this.http.get(url, {responseType: 'text'});
      }),
      concatMap(myData => {
        let data;
        try {
          data = JSON.parse(myData);
        } catch (e) {
          this.popupMessage = "Cannot assign, be sure to select a scene first";
          this.cannotRegister();
          Log.d(logInfo, LogTag.REGISTRATION, myData);
          this.disableUI(false);
          return of(null)
        }
        if (data.status) {
          (this.playerService as PlayerBaseService).stationId = data.stationId;
          return (this.playerService as PlayerBaseService).saveStationInfo();
        } else {
          debugger;
          let msg = data.message;
          if (msg=="exceeded") {
            msg = "Number of licenses has already been reached. Please contact your admin.";
          }
          const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '200px',
            width: '400px',
            data: {name: msg}
          });

          return of(null);
        }
      }),
      filter(res => {
        return (res != null)
      }),
      switchMap(value => {
        Log.d(logInfo, LogTag.REGISTRATION, 'registration completed');
        (this.playerService as PlayerBaseService).data['user'] = null;
        (this.playerService as PlayerBaseService).data['pass'] = null;
        return of('registered')
      }),
      take(1)
    )
  }
}
